import { Translate } from '@dreryk/react-common';
import {
   IconFillColor,
   IconSize,
   IconWrapper,
   QuestionmarkCircleIcon,
   StyledFlex,
   Tooltip,
} from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys } from '../../../translations';

import { TooltipText } from './TooltipText';

export const AddGrantingDateFieldLabel = (): JSX.Element => {
   return (
      <StyledFlex gap={'2px'} alignItems={'center'}>
         <Translate>
            {entitlementStatementsTranslationKeys.createModal.addTheDateOfGrantingTheEntitlementStatement}
         </Translate>
         <Tooltip maxWidth='324px' content={<TooltipText />} testId='tooltip'>
            <IconWrapper testId={'entitlementType'} fillColor={IconFillColor.PRIMARY} size={IconSize.SMALL}>
               <QuestionmarkCircleIcon />
            </IconWrapper>
         </Tooltip>
      </StyledFlex>
   );
};
